var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8053 0C15.8628 0 15.9203 0 15.981 0C16.1221 1.52637 15.457 2.66688 14.6488 3.49279C13.8558 4.31301 12.7698 5.10851 11.0134 4.98781C10.8963 3.48329 11.5624 2.42737 12.3695 1.60336C13.1181 0.835419 14.4904 0.152067 15.8053 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17.0417C21 17.0574 21 17.0712 21 17.0859C20.5344 18.4415 19.8702 19.6032 19.0597 20.6814C18.3198 21.6602 17.4131 22.9774 15.7941 22.9774C14.3951 22.9774 13.4659 22.1127 12.0322 22.0891C10.5155 22.0655 9.68146 22.8121 8.29479 23C8.13616 23 7.97754 23 7.82199 23C6.80373 22.8583 5.98196 22.0832 5.38328 21.3847C3.61796 19.3209 2.2538 16.6551 2 13.2436C2 12.9091 2 12.5756 2 12.2412C2.10745 9.79959 3.34165 7.81446 4.98212 6.85239C5.84789 6.34086 7.03808 5.90507 8.36335 6.09985C8.93133 6.18445 9.51158 6.37135 10.0202 6.55629C10.5022 6.73434 11.105 7.05011 11.676 7.03339C12.0629 7.02257 12.4476 6.82878 12.8376 6.69204C13.9796 6.29561 15.0992 5.84113 16.5749 6.0546C18.3484 6.31233 19.6072 7.06979 20.385 8.23844C18.8847 9.15624 17.6986 10.5393 17.9012 12.9012C18.0813 15.0467 19.379 16.3019 21 17.0417Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleImg);
export default __webpack_public_path__ + "static/media/apple-img.5fd2f9002f077f1a26328432c6df8b2b.svg";
export { ForwardRef as ReactComponent };